import { makeStyles, Theme, Typography } from "@material-ui/core";
import {
  ToggleButtonGroup,
  ToggleButton as MaterialToggleButton,
} from "@material-ui/lab";
import clsx from "clsx";
import React from "react";

const useStyles = makeStyles(({ typography, palette }: Theme) => ({
  toggleButton: {
    "& > span": {
      gap: 6,
      alignItems: "center",
      ...typography.button,
    },
  },
  toggleButtonActive: {
    color: `${palette.primary.main} !important`,
    backgroundColor: `rgba(0, 80, 140, 0.1) !important`,
    borderColor: `rgba(0, 80, 140, 0.2) !important`,
  },
  container: {
    height: 40,
  },
}));

type ToggleButtonProps<T extends string> = {
  states: { value: T; label: string; icon?: React.ReactNode }[];
  currectState: string;
  onChangeState: (state: T) => void;
  className?: string;
};

const ToggleButton = <T extends string>({
  states,
  currectState,
  onChangeState = () => {},
  className,
}: ToggleButtonProps<T>) => {
  const classes = useStyles();

  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      className={clsx(classes.container, className)}
      value={currectState}
      onChange={(_, mode) => onChangeState(mode || currectState)}
      aria-label="Editor mode"
    >
      {states.map((state) => (
        <MaterialToggleButton
          key={state.value}
          value={state.value}
          aria-label={state.label}
          className={clsx(
            classes.toggleButton,
            state.value === currectState && classes.toggleButtonActive,
          )}
        >
          {state.icon}
          <Typography variant="subtitle1">{state.label}</Typography>
        </MaterialToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default ToggleButton;
